(function () {
  if (window.__designGroupSwatchesGlobalInit) return;
  window.__designGroupSwatchesGlobalInit = true;

  var GAP = 8;

  /* ------------------------------------------------------------------
     Shared catalog lookup
     Pulls the catalog from the Storefront API once per page load and
     reuses it for every swatch block (product page, quick view, variant
     changes, product cards). Before this, every block re-scanned the
     whole catalog.
  ------------------------------------------------------------------ */

  var catalogPromise = null;

  function getCatalog() {
    if (catalogPromise) return catalogPromise;
    var config = window.__storefrontApiConfig;
    if (!config || !config.token || !config.url) return Promise.reject(new Error('Missing Storefront API config'));

    var query =
      'query DesignGroupCatalog($cursor: String) { products(first: 250, after: $cursor) { pageInfo { hasNextPage endCursor } edges { node { id handle title category { name } metafield(namespace: "custom", key: "design_group") { value } featuredImage { url(transform: { maxWidth: 120 }) } } } } }';

    function fetchPage(cursor, collected) {
      return fetch(config.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.token
        },
        body: JSON.stringify({ query: query, variables: { cursor: cursor } })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          var data = res.data && res.data.products;
          if (!data) throw new Error('Storefront API returned no products');
          data.edges.forEach(function (edge) {
            var node = edge.node;
            // Only keep products that have a design group ID
            if (node && node.metafield && node.metafield.value) collected.push(node);
          });
          if (data.pageInfo && data.pageInfo.hasNextPage && data.pageInfo.endCursor) {
            return fetchPage(data.pageInfo.endCursor, collected);
          }
          return collected;
        });
    }

    catalogPromise = fetchPage(null, []).catch(function (err) {
      catalogPromise = null; // allow a retry on the next render
      throw err;
    });
    return catalogPromise;
  }

  // Products in the same design group AND the same category as the current product
  function getMatches(catalog, groupId, category) {
    return catalog.filter(function (node) {
      if (node.metafield.value !== groupId) return false;
      if (!category) return true;
      return node.category && node.category.name === category;
    });
  }

  function productIdFromGid(gid) {
    return (gid || '').split('/').pop() || '';
  }

  function buildSwatchLink(node, currentId, classPrefix, imageSize) {
    var isCurrent = !!(currentId && productIdFromGid(node.id) === currentId);
    var title = node.title || '';

    var link = document.createElement('a');
    link.href = (location.origin || '') + '/products/' + (node.handle || '');
    link.className = classPrefix + (isCurrent ? ' ' + classPrefix + '--current' : '');
    link.setAttribute('aria-label', title);
    if (isCurrent) link.setAttribute('aria-current', 'true');

    if (node.featuredImage && node.featuredImage.url) {
      var img = document.createElement('img');
      img.src = node.featuredImage.url;
      img.alt = title;
      img.className = classPrefix + '__image';
      img.loading = 'lazy';
      img.width = imageSize;
      img.height = imageSize;
      link.appendChild(img);
    } else {
      var placeholder = document.createElement('div');
      placeholder.className = classPrefix + '__image ' + classPrefix + '__image--placeholder';
      placeholder.textContent = title.length > 10 ? title.substring(0, 10) + '…' : title;
      link.appendChild(placeholder);
    }
    return link;
  }

  /* ------------------------------------------------------------------
     Product page and quick view swatches
     Runs on first load, and again whenever the theme swaps in new
     product HTML (variant changes, quick view).
  ------------------------------------------------------------------ */

  function runDesignGroupSwatchesPDP() {
    var containers = document.querySelectorAll(
      '[data-design-group-swatches-pdp][data-api-enabled="true"]:not([data-api-loaded])'
    );
    if (!containers.length) return;

    // Mark right away so repeat calls do not double-process
    containers.forEach(function (container) {
      container.setAttribute('data-api-loaded', 'pending');
    });

    getCatalog()
      .then(function (catalog) {
        containers.forEach(function (container) {
          var groupId = container.getAttribute('data-design-group-id') || '';
          var category = container.getAttribute('data-product-category') || '';
          var currentId = container.getAttribute('data-current-product-id') || '';
          var matches = getMatches(catalog, groupId, category);
          var list = container.querySelector('[data-api-swatches-container="true"]');

          if (matches.length <= 1 || !list) {
            container.style.display = 'none';
          } else {
            list.textContent = '';
            matches.forEach(function (node) {
              list.appendChild(buildSwatchLink(node, currentId, 'design-group-swatch', 60));
            });
            container.style.display = 'block';
          }
          container.setAttribute('data-api-loaded', 'true');
        });
      })
      .catch(function () {
        containers.forEach(function (container) {
          container.style.display = 'none';
          container.setAttribute('data-api-loaded', 'true');
        });
      });
  }

  /* ------------------------------------------------------------------
     Product card swatches (dropdown version)
     Only used if a product card still renders the older swatch dropdown.
     The simplified "More Colors Available" card label does not use this.
  ------------------------------------------------------------------ */

  function getPortal() {
    var id = 'design-group-dropdown-portal';
    var portal = document.getElementById(id);
    if (!portal) {
      portal = document.createElement('div');
      portal.id = id;
      portal.style.cssText = 'position:fixed;inset:0;z-index:9998;pointer-events:none;';
      document.body.appendChild(portal);
    }
    return portal;
  }

  function positionInPortal(trigger, dropdown) {
    var rect = trigger.getBoundingClientRect();
    dropdown.style.top = rect.bottom + GAP + 'px';
    dropdown.style.left = rect.left + 'px';
  }

  function closeDropdown(container, trigger, dropdown) {
    if (!container || !dropdown) return;
    var home = dropdown._designGroupHome;
    if (home && dropdown.getAttribute('data-portaled') === 'true') {
      dropdown.removeAttribute('data-portaled');
      dropdown.style.position = '';
      dropdown.style.top = '';
      dropdown.style.left = '';
      home.appendChild(dropdown);
    }
    container.setAttribute('data-open', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    dropdown.setAttribute('aria-hidden', 'true');
  }

  function openDropdownInPortal(container, trigger, dropdown) {
    dropdown._designGroupHome = container;
    dropdown.setAttribute('data-portaled', 'true');
    dropdown.style.position = 'fixed';
    dropdown.style.zIndex = '2147483647';
    dropdown.style.pointerEvents = 'auto';
    getPortal().appendChild(dropdown);
    positionInPortal(trigger, dropdown);
  }

  function repositionPortaledDropdowns() {
    var portal = document.getElementById('design-group-dropdown-portal');
    if (!portal) return;
    portal
      .querySelectorAll('.grid-product__design-group-swatches__dropdown[data-portaled="true"]')
      .forEach(function (dropdown) {
        var container = dropdown._designGroupHome;
        if (!container) return;
        var trigger = container.querySelector('.grid-product__design-group-swatch-trigger');
        if (trigger) positionInPortal(trigger, dropdown);
      });
  }

  function initDesignGroupSwatches() {
    var containers = document.querySelectorAll('[data-design-group-swatches]:not([data-initialized])');
    containers.forEach(function (container) {
      container.setAttribute('data-initialized', 'true');
      var trigger = container.querySelector('.grid-product__design-group-swatch-trigger');
      var dropdown = container.querySelector('.grid-product__design-group-swatches__dropdown');
      if (!trigger || !dropdown) return;
      container._designGroupDropdown = dropdown;
      container._designGroupTrigger = trigger;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = container.getAttribute('data-open') === 'true';
        document.querySelectorAll('[data-design-group-swatches]').forEach(function (other) {
          if (other !== container) {
            closeDropdown(other, other._designGroupTrigger, other._designGroupDropdown);
          }
        });
        var newState = !isOpen;
        container.setAttribute('data-open', newState ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', newState ? 'true' : 'false');
        dropdown.setAttribute('aria-hidden', newState ? 'false' : 'true');
        if (newState) openDropdownInPortal(container, trigger, dropdown);
        else closeDropdown(container, trigger, dropdown);
      });
    });
  }

  function runStorefrontApiDesignGroupCount() {
    var containers = document.querySelectorAll(
      '[data-design-group-swatches][data-api-count="true"]:not([data-api-loaded])'
    );
    if (!containers.length) return;

    containers.forEach(function (el) {
      el.setAttribute('data-api-loaded', 'pending');
    });

    getCatalog()
      .then(function (catalog) {
        containers.forEach(function (el) {
          var groupId = el.getAttribute('data-design-group-id') || '';
          var category = el.getAttribute('data-product-category') || '';
          var currentId = el.getAttribute('data-current-product-id') || '';
          var matches = getMatches(catalog, groupId, category);
          var countEl = el.querySelector('[data-design-group-count]');
          if (countEl) countEl.textContent = matches.length + ' Colors';

          if (matches.length <= 1) {
            el.style.display = 'none';
          } else {
            var dropdownContent = el.querySelector(
              '.grid-product__design-group-swatches__dropdown-content[data-api-dropdown="true"]'
            );
            if (dropdownContent) {
              dropdownContent.textContent = '';
              matches.forEach(function (node) {
                var link = buildSwatchLink(node, currentId, 'grid-product__design-group-swatch', 40);
                link.setAttribute('role', 'menuitem');
                dropdownContent.appendChild(link);
              });
            }
          }
          el.setAttribute('data-api-loaded', 'true');
        });
      })
      .catch(function () {
        containers.forEach(function (el) {
          el.style.display = 'none';
          el.setAttribute('data-api-loaded', 'true');
        });
      });
  }

  /* ------------------------------------------------------------------
     Wiring
  ------------------------------------------------------------------ */

  function runAll() {
    initDesignGroupSwatches();
    runStorefrontApiDesignGroupCount();
    runDesignGroupSwatchesPDP();
  }

  window.initDesignGroupSwatches = initDesignGroupSwatches;
  window.runStorefrontApiDesignGroupCount = runStorefrontApiDesignGroupCount;
  window.runDesignGroupSwatchesPDP = runDesignGroupSwatchesPDP;

  if (!window.__designGroupSwatchesScrollResizeBound) {
    window.__designGroupSwatchesScrollResizeBound = true;
    window.addEventListener('scroll', repositionPortaledDropdowns, true);
    window.addEventListener('resize', repositionPortaledDropdowns);
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('.grid-product__design-group-swatch-trigger');
      if (trigger) return;
      if (
        !e.target.closest('[data-design-group-swatches]') &&
        !e.target.closest('.grid-product__design-group-swatches__dropdown')
      ) {
        document.querySelectorAll('[data-design-group-swatches][data-open="true"]').forEach(function (container) {
          closeDropdown(container, container._designGroupTrigger, container._designGroupDropdown);
        });
      }
    },
    true
  );

  // Watch for product HTML the theme adds after page load:
  // variant changes re-render the product info, and quick view loads a product into a popup.
  if (!window.__designGroupSwatchesObserverBound) {
    window.__designGroupSwatchesObserverBound = true;
    var WATCH_SELECTOR =
      '[data-design-group-swatches], [data-design-group-swatches-pdp], recently-viewed, product-recommendations';
    var tick = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;
      for (var i = 0; i < mutations.length && !shouldRun; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if ((node.matches && node.matches(WATCH_SELECTOR)) || (node.querySelector && node.querySelector(WATCH_SELECTOR))) {
            shouldRun = true;
            break;
          }
        }
      }
      if (!shouldRun) return;
      if (tick) clearTimeout(tick);
      tick = setTimeout(runAll, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();